/** @format */

import {format} from 'date-fns';

/**
 * Дата съёма данных для шапки документа: `generatedAt` отчёта без времени,
 * а если его нет — конец периода.
 *
 * `format` из date-fns бросает `RangeError` на невалидной дате, а error
 * boundary в приложении нет — непригодный `generatedAt` (мусор с бэкенда)
 * ронял бы страницу белым экраном. Проверяем `getTime()` до форматирования
 * и откатываемся на `periodEnd`; если и он непригоден, отдаём его как есть,
 * но не бросаем.
 */
export function toDataDate(generatedAt: string | null | undefined, periodEnd: string): string {
  const primary = new Date(generatedAt || periodEnd);
  if (!Number.isNaN(primary.getTime())) return format(primary, 'yyyy-MM-dd');

  const fallback = new Date(periodEnd);
  if (!Number.isNaN(fallback.getTime())) return format(fallback, 'yyyy-MM-dd');

  return periodEnd;
}
